/* ============================================================
   MM Collections onglets — pastilles + carrousel Splide
   - bascule au clic (délégation, multi-instances, post-AJAX)
   - montage Splide à la volée (panneau visible) + refresh
   - attend que Splide (chargé en defer via CDN) soit prêt
   ============================================================ */
(function () {
  // Exécute cb dès que Splide est disponible (Splide est chargé en defer)
  function whenSplideReady(cb) {
    if (typeof Splide !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Splide !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function mountSplide(panel) {
    var el = panel.querySelector('.mm-cco__splide');
    if (!el) return;

    // Déjà monté : on rafraîchit (le panneau vient d'être ré-affiché)
    if (panel._splide) {
      panel._splide.refresh();
      return;
    }

    whenSplideReady(function () {
      if (panel._splide) return;
      var splide = new Splide(el, {
        type: 'slide',
        arrows: true,
        pagination: false,
        autoplay: false,
        perPage: 5,
        perMove: 1,
        gap: 17.5,
        padding: { left: 16, right: 16 },
        breakpoints: {
          1200: { perPage: 3 },
          950: { perPage: 2 },
          768: {
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            gap: 16,
            padding: { left: 16, right: 140 }
          }
        }
      });
      splide.mount();
      panel._splide = splide;

      // Le panneau vient d'être affiché : au montage, Splide peut mesurer la
      // largeur avant que le layout soit stabilisé et croire à tort qu'il y a
      // débordement (is-overflow) => cartes collées à gauche. On recalcule sur
      // la frame suivante pour obtenir le bon centrage dès le 1er affichage.
      requestAnimationFrame(function () {
        if (panel._splide) panel._splide.refresh();
      });
    });
  }

  function activateTab(tab) {
    var root = tab.closest('[data-mm-cco]');
    if (!root) return;
    var id = tab.getAttribute('data-cco-tab');

    root.querySelectorAll('.mm-cco__tab').forEach(function (t) {
      var isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var target = null;
    root.querySelectorAll('.mm-cco__panel').forEach(function (p) {
      var isActive = p.getAttribute('data-cco-panel') === id;
      p.classList.toggle('is-active', isActive);
      if (isActive) target = p;
    });

    // Le panneau cible est désormais visible : on peut monter/rafraîchir
    if (target) mountSplide(target);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.mm-cco__tab');
    if (tab) activateTab(tab);
  });

  // Montage initial du panneau actif de chaque instance
  document.querySelectorAll('[data-mm-cco]').forEach(function (root) {
    var active = root.querySelector('.mm-cco__panel.is-active');
    if (active) mountSplide(active);
  });
})();
